export const hierarchyLevels = [
    { 
        text: "Division", value: "DIVISION"
    },
    { 
        text: "Area", value: "AREA"
    },
    { 
        text: "Departamento", value: "DEPARTAMENTO"
    },
    { 
        text: "Linea", value: "LINEA"
    },
    { 
        text: "Seccion", value: "SECCION"
    },
    { 
        text: "Familia", value: "FAMILIA"
    },
    { 
        text: "Subfamilia", value: "SUBFAMILIA"
    }
]